import React, { useEffect, useState } from 'react';
import { Box, Typography, Alert, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Loader from '../../components/Common/Loader';

const AutoLogin = () => {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const org = searchParams.get('org');
    const key = searchParams.get('key');
    const email = searchParams.get('email');

    if (!org || !key) {
      setError('Invalid link — missing organisation or key.');
      return;
    }

    // Clear any existing session so switching orgs via different links always works
    localStorage.removeItem('token');
    localStorage.removeItem('lastRoute');

    api.get('/auth/magic-login', { params: { org, key, ...(email ? { email } : {}) } })
      .then(res => {
        if (res.data.success) {
          login(res.data.token, res.data.user);
          navigate('/dashboard', { replace: true });
        } else {
          setError('Access denied.');
        }
      })
      .catch(err => {
        setError(err.response?.data?.error || 'Login failed. Check the link and try again.');
      });
  }, [searchParams, login, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        gap: 2
      }}
    >
      {error ? (
        <>
          <Alert severity="error" sx={{ maxWidth: 400 }}>{error}</Alert>
          <Button variant="outlined" onClick={() => navigate('/login')}>
            Back to Login
          </Button>
        </>
      ) : (
        <>
          <Loader size={52} />
          <Typography variant="body1" color="text.secondary">
            Signing you in…
          </Typography>
        </>
      )}
    </Box>
  );
};

export default AutoLogin;
